import React from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import {
  DataGrid,
} from '@mui/x-data-grid';

function RenderAnalysisAssetsTable({ assets }) {
  const columns = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'team', headerName: 'Team', flex: 1 },
    { field: 'position', headerName: 'Position', flex: 1 },
    { field: 'currentCost', headerName: 'Salary', flex: 1 },
    { field: 'dkPoints', headerName: 'Points', flex: 1 },
    { field: 'ccUsage', headerName: 'Usage', flex: 1 },
  ];

  return (
    <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, color: '#006ee6' }}>
        Optimal Teams
      </Typography>
      <Box sx={{ height: 400, width: '60%' }}>
        <DataGrid
          rows={assets}
          columns={columns}
          getRowId={(row) => row.name + row.team + row.position}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableColumnMenu
          disableSelectionOnClick
          hideFooterPagination={assets.length <= 10}
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#006ee6',
              color: 'white',
              fontSize: '17px',
            },
            '& .MuiDataGrid-row': {
              backgroundColor: '#FFF',
              fontSize: '17px',
            },
          }}
        />
      </Box>
    </Paper>
  );
}

export default RenderAnalysisAssetsTable;